/* unplugin-vue-components disabled */import { render } from "./DailyInspection.vue?vue&type=template&id=3c1f7fa5&scoped=true&ts=true"
import script from "./DailyInspection.vue?vue&type=script&lang=ts"
export * from "./DailyInspection.vue?vue&type=script&lang=ts"

import "./DailyInspection.vue?vue&type=style&index=0&id=3c1f7fa5&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1f7fa5"]])

export default __exports__